import type { AptiRequestConfig } from "@/lib/types/api";
import { getGroupAuthType } from "@/redux/actions/auth";
import type {
  GoalAndObjectiveTextResponse,
  GoalsAndObjectivesResponse,
  ModalityTextResponse,
  PatientArticulatedGoalsResponse,
  PatientMedicalCautionsResponse,
  PatientStrengthAndCautionOptionsResponse,
  PatientStrengthsResponse,
} from "@/core/types";
import { GROUP_AUTH_HEADER_NAME } from "@/constants/axios";
import { httpAuth } from "@/utils/axios";

export const carePlanRequestsTyped = {
  get_goal_and_objective_text: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: string;
  }): Promise<GoalAndObjectiveTextResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/care-plan/${patientId}/get_goal_and_objective_text`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<GoalAndObjectiveTextResponse>;
  },

  get_goals_and_objectives: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: string;
  }): Promise<GoalsAndObjectivesResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/care-plan/${patientId}/get_goals_and_objectives`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<GoalsAndObjectivesResponse>;
  },

  get_modality_text: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: string;
  }): Promise<ModalityTextResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/care-plan/${patientId}/get_modality_text`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<ModalityTextResponse>;
  },

  get_patient_articulated_goals: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: string;
  }): Promise<PatientArticulatedGoalsResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/care-plan/${patientId}/get_patient_articulated_goals`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<PatientArticulatedGoalsResponse>;
  },

  get_patient_medical_cautions: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: string;
  }): Promise<PatientMedicalCautionsResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/care-plan/${patientId}/get_patient_medical_cautions`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<PatientMedicalCautionsResponse>;
  },

  get_patient_strength_and_caution_options: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: string;
  }): Promise<PatientStrengthAndCautionOptionsResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/care-plan/${patientId}/get_patient_strength_and_caution_options`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<PatientStrengthAndCautionOptionsResponse>;
  },

  get_patient_strengths: function ({
    params,
    patientId,
  }: {
    params?: Record<string, unknown>;
    patientId: string;
  }): Promise<PatientStrengthsResponse> {
    const config = {
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params,
      url: `/v1/care-plan/${patientId}/get_patient_strengths`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<PatientStrengthsResponse>;
  },
};
